import { Scale, Size, CreateElement, Log } from "../../../MyHelpers";
import { IReadOnlyResourceManager, ResourceManager } from "../../../ResourceManager/ResourceManager";
import { SecondSceenHelp2Slides, SecondScreenHelpParams } from "./SecondSceenHelp2Slides";
import { SlideFactory2Side } from "./SlideFactory2Side";
import { SlideFactory2Params, Slide } from "./Slides/Slide";
import { SlideType } from "./SlideType";
import { TweenLite, TimelineMax, TimelineLite } from "gsap";
import { JackpotDisplayType, Settings } from "../../../Settings";

export class SecondSceenHelp2Slides1Screens extends SecondSceenHelp2Slides {


	constructor(params: SecondScreenHelpParams) {
		super(params);
		this.systemContext = params.systemContext.CreateSubContext("SliderSide1Screrens");
		this.translator = params.translator;
		this.initData = params.initData;
		this.logGroup = params.logGroup.Add("SliderSide1Screrens");
		this.resid = params.resid.Add("SliderSide1Screrens");
		this.view.style.top = Scale.Ypx(0);
		this.view.style.height = Scale.Ypx(180);
		

	}

	public override PrepareSlides() {


		this.slideFactoryLeft = new SlideFactory2Side();
		//this.slideFactoryRight = new SlideFactory2Side();
		//LOAD SLIDER FOR GAME TITLE
		this.featuresleft.push(SlideType.GameTitle);
		if (Settings.JackpotDisplayType != JackpotDisplayType.PaytableJackpotDisplay) {
			this.featuresleft.push(SlideType.GameTitleJackpotDisplay);
		}





		let slideParams: SlideFactory2Params = {
			gameName: this.params.gameName,
			path: this.gamePath,
			resid: this.resid,
			commonPath: this.commonPath,
			slideFactory: this.slideFactoryLeft,
			translator: this.translator,
			params: this.initData.BonusConfiguration,
			logGroup: this.logGroup,
			systemContext: this.systemContext
		}


		for (let i = 0; i < this.featuresleft.length; i++) {
			let slide: Slide = this.slideFactoryLeft.CreatSlide2side(this.featuresleft[i], this.initData, slideParams, new Size(Scale.W(964), Scale.H(476)))

			this.helpSlidesLeft.push(slide);
			this.allSlides.push(slide);
		}



		this.nextSlideTimer = this.systemContext.TimingContext().CreateInterval("nextSlideTimer", this.nextSlideInterval, () => this.NextSlide());

	}

	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {



		this.LeftView = CreateElement("div", {
			classes: ["LeftView"],
			parentToAppend: this.view,
			style: {
				top: "0px",
				left: Scale.Xpx(30),
				position: "absolute",
				width: Scale.Wpx(700),
				height: Scale.Hpx(180),
				display: "flex",
				flexDirection: "row",
			}
		});



		for (let i = 0; i < this.allSlides.length; i++) {
			await this.allSlides[i].ResourcesLoaded(resourceManager);
			TweenLite.set(this.allSlides[i].View(), { autoAlpha: 0 });
		}

		for (let i = 0; i < this.helpSlidesLeft.length; i++) {
			this.LeftView.appendChild(this.helpSlidesLeft[i].View());
		}



		if (this.helpSlidesLeft.length > 1) {
			this.currentLeftSlideIndex = 0;
			this.currentLeftSlide = this.helpSlidesLeft[0];
		}

	}


	protected override leftAnim: TimelineMax = null;


	protected override NextSlide() {
		let transitionMillis = 1000;
		let animDistance = 300;

		// left
		if (this.helpSlidesLeft.length > 1) {

			let currentLeftSlideIndex = this.currentLeftSlideIndex;
			let currentLeftSlide = this.currentLeftSlide;

			let nextLeftSlideIndex = (this.currentLeftSlideIndex + 1) % this.helpSlidesLeft.length;
			let nextLeftSlide = this.helpSlidesLeft[nextLeftSlideIndex];
			this.nextLeftSlide = nextLeftSlide;

			//// Log.Debug(this.logGroup, `NextSlide() currentLeftSlideIndex: ${this.currentLeftSlideIndex}, nextLeftSlideIndex: ${nextLeftSlideIndex}`);

			this.leftAnim = new TimelineMax({ paused: true });

			// current slide: mode left fade out
			this.leftAnim.fromTo(this.currentLeftSlide.View(), transitionMillis / 1000, {autoAlpha: 1,  }, { autoAlpha: 0 });

			// next slide: move right fade in
			this.leftAnim.fromTo(nextLeftSlide.View(), transitionMillis / 1000, { autoAlpha: 0 }, { autoAlpha: 1 }, "-=" + (transitionMillis / 1000));

			this.leftAnim.eventCallback("onStart", () => {
				//// Log.Debug(this.logGroup, "NextSlide() left transition started, starting next slide");
				nextLeftSlide.Start();
			});

			this.leftAnim.eventCallback("onComplete", () => {
				//// Log.Debug(this.logGroup, "NextSlide() left transition complete, stopping current slide");
				currentLeftSlide.Stop();

				this.currentLeftSlideIndex = nextLeftSlideIndex;
				this.currentLeftSlide = nextLeftSlide;
				this.nextLeftSlide = null;
			});

			this.leftAnim.play();
		}
	}


	protected override started = false;
	public override Start(): void {
		if (!this.started) {
			this.started = true;
			this.nextSlideTimer.Start();

			TweenLite.set(this.currentLeftSlide.View(), { scale: 1, x: 0, autoAlpha: 1 });
			this.currentLeftSlide.Start();


		}
		else {
		}
	}

	public override Stop(): void {
		if (this.started) {
			this.started = false;
			this.nextSlideTimer.Stop();

			// stop all sprites
			this.allSlides.forEach(s => s.Stop());
		}
	}

	public override Reset(): void {
		// if (this.helpSlidesLeft.length > 1 && this.helpSlidesRight.length > 1)
		// {
		//     TweenLite.set(this.helpSlidesLeft[this.currentLeftSlideIndex].View(), { x: (10) + "%" });
		//     TweenLite.set(this.helpSlidesRight[ this.currentRightSlideIndex].View(), { x: (-10) + "%" });
		// }
	}

	public override View(): HTMLElement {
		return this.view;
	}

	public override Hide(): void {
		this.view.style.visibility = "hidden";
	}

	public override Update(): void {

		// update only current slide?
		if (this.started) {
			if (this.currentLeftSlide != null) {
				this.currentLeftSlide.Update();
			}

			if (this.nextLeftSlide != null) {
				this.nextLeftSlide.Update();
			}
		}
	}
}